import BaseAction from "../utils/BaseAction";
import { IReportFilter } from "../components/pages/reports/Index";

export type IOfferLeadActions = ClassInstance<typeof _OfferLeadActions>;
class _OfferLeadActions extends BaseAction {

    async doList(query: IReportFilter & {
        sort?: string;
        sortDirection?: number;
        skip?: number;
        limit?: number;
    }) {
        const data = await this.apiRequestWithErrorAlert<{
            items: ServerTypes.Console.IOfferLeadReportItem[];
            count: number;
        }>("/reports/offer/leads/json", "POST", { ...query });
        if (data && data.items && data.items.length) {
            return { items: data.items, total: data.count };
        } else {
            return { items: [], total: 0 };
        }
    }


    async doDownload(query: IReportFilter & {
        sort?: string;
        sortDirection?: number;
        skip?: number;
        limit?: number;
    }) {
        const data = await this.apiRequest("/reports/offer/leads/csv", "POST", { ...query });
        if (data) {
            return this.downloadFile("offerleads", data);
        }
    }
}

export const OfferLeadActions = new _OfferLeadActions();
